import { useRef, useState } from "react";
import {
  ResponsiveContainer,
  ComposedChart,
  Label,
  Line,
  Tooltip,
  Legend,
  BarChart,
  XAxis,
  YAxis,
  Bar,
  LabelList,
  ReferenceLine,
} from "recharts";
import { numberFormatter } from "../../utils";

const SalesTrend = (props: any) => {
  const { data, year } = props;
  const [showTable,setShowTable]=useState(false)

  const [tooltip, setTooltip] = useState<any>({
    district: "",
    show: false,
    costPercent: 0,
    l4Category: "",
  });
  const customTooltip = ({ active, payload }: any) => {
    console.log(payload);
    if (active && payload && payload.length) {
      const data = payload;
      return (
        <div className="custom-tooltip">
          <p className="label" style={{ padding: "0", margin: "0" }}>
            <label
              style={{
                color: "#C8C8C8",
                fontSize: "10px",
                fontWeight: "normal",
              }}
            >
              Month :{" "}
            </label>
            <label
              style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}
            >
              {data[0]?.payload?.month}
            </label>
          </p>
          {data?.map((val: any, i: any) => {
            return (
              <>
                {val?.dataKey === "forecasted" &&
                  val?.value !== data[i - 1]?.value && (
                    <p className="label" style={{ padding: "0", margin: "0" }}>
                      <label
                        style={{
                          color: "#C8C8C8",
                          fontSize: "10px",
                          fontWeight: "normal",
                        }}
                        className="capitalize"
                      >
                        {val?.dataKey} :{" "}
                      </label>
                      <label
                        style={{
                          color: "#EAEAEA",
                          fontSize: "10px",
                          fontWeight: "bold",
                        }}
                      >
                        {numberFormatter(val?.value, 2, "$")}
                      </label>
                    </p>
                  )}
                {val?.dataKey !== "forecasted" && (
                  <p className="label" style={{ padding: "0", margin: "0" }}>
                    <label
                      style={{
                        color: "#C8C8C8",
                        fontSize: "10px",
                        fontWeight: "normal",
                      }}
                      className="capitalize"
                    >
                      {val?.dataKey} :{" "}
                    </label>
                    <label
                      style={{
                        color: "#EAEAEA",
                        fontSize: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      {numberFormatter(val?.value, 2, "$")}
                    </label>
                  </p>
                )}
              </>
            );
          })}
        </div>
      );
    }
  };

  return (
    <div className="h-full w-full">
      <ResponsiveContainer
        width="100%"
        height={showTable?"45%":'85%'}
        className="bg-white p-[2vh] py-[0]"
      >
        <ComposedChart data={data} className="" margin={{ top: 20 }}>
          <XAxis dataKey="month" stroke="black" fontSize="1.5vh"></XAxis>
          <YAxis
            stroke="black"
            fontSize="1.5vh"
            tickFormatter={(value: number) => numberFormatter(value, 0, "$")}
            domain={["dataMin - 10000000", "dataMax + 10000000"]}
            interval={0}
          ></YAxis>

          <Tooltip
            contentStyle={{
              color: "white",
              backgroundColor: "rgba(121, 119, 114, 1)",
            }}
            cursor={{ strokeDasharray: "3 3", fill: "#212121" }}
            content={customTooltip}
          />

          {year?.map((key: any, i: any) => {
            return (
              <Line
                type="linear"
                dataKey={key}
                stroke={i === 0 ? "gray" : i === 1 ? "#82C8FA" : "#287AB5"}
                strokeDasharray={"0"}
                connectNulls={false}
                strokeWidth={3}
                isAnimationActive={false}
              />
            );
          })}

          <Line
            type="linear"
            dataKey="forecasted"
            stroke="#287AB5"
            name="Forecasted"
            strokeDasharray={"3 3"}
            connectNulls={true}
            isAnimationActive={false}
            strokeWidth={3}
          />
        </ComposedChart>
      </ResponsiveContainer>

      {/* <div className="h-5 flex items-center justify-center">
        <div className="flex space-x-4 justify-center">
          <svg width="4%" className="mr-2 mt-1" height="8">
            <rect x="0" y="0" width="100%" height="8" fill="" />
            <line
              x1="0"
              y1="4"
              x2="100%"
              y2="4"
              stroke="gray"
              stroke-width="2"
              // stroke-dasharray="10,10"
            />
          </svg>{" "}
          <span className="text-[0.6vw]">2023</span>
          <svg width="4%" className="mr-2 mt-1" height="8">
            <rect x="0" y="0" width="100%" height="8" fill="" />
            <line
              x1="0"
              y1="4"
              x2="100%"
              y2="4"
              stroke="#82C8FA"
              stroke-width="2"
              // stroke-dasharray="10,10"
            />
          </svg>{" "}
          <span className="text-[0.6vw]">2024</span>
          <svg width="4%" className="mr-2 mt-1" height="8">
            <rect x="0" y="0" width="100%" height="8" fill="" />
            <line
              x1="0"
              y1="4"
              x2="100%"
              y2="4"
              stroke="#287AB5"
              stroke-width="2"
              // stroke-dasharray="10,10"
            />
          </svg>{" "}
          <span className="text-[0.6vw]">2025</span>
          <svg width="4%" className="mr-2 mt-1" height="8">
            <rect x="0" y="0" width="100%" height="8" fill="" />
            <line
              x1="0"
              y1="4"
              x2="100%"
              y2="4"
              stroke="#287AB5"
              stroke-width="2"
              stroke-dasharray="10,10"
            />
          </svg>{" "}
          <span className="text-[0.6vw]">2025F</span>
        </div>
        {!showTable&&<svg onClick={()=>setShowTable(true)} width="32" height="32" viewBox="0 0 32 32">
          <circle
            cx="16"
            cy="16"
            r="14"
            stroke="#a4f504"
            stroke-width="2"
            fill="#000"
          />
          <polyline
            points="12,18 16,12 20,18"
            fill="none"
            stroke="#a4f504"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>}
{showTable&&<svg onClick={()=>setShowTable(false)} width="32" height="32" viewBox="0 0 32 32">
  <circle cx="16" cy="16" r="14" stroke="#a4f504" stroke-width="2" fill="#000"/>
  <polyline points="12,14 16,20 20,14" fill="none" stroke="#a4f504" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>}

      </div> */}

      <div className="contentFooter !justify-between">
				<CustomLegend></CustomLegend>
         {!showTable&&<svg className="cursor-pointer" onClick={()=>setShowTable(true)} width="6.5vh" height="6.5vh" viewBox="0 0 32 32">
          <circle
            cx="16"
            cy="16"
            r="14"
            stroke="#006400"
            stroke-width="2"
            fill="white"
          />
          <polyline
            points="12,18 16,12 20,18"
            fill="none"
            stroke="#006400"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>}
        {showTable&&<svg className="cursor-pointer"  onClick={()=>setShowTable(false)} width="6.5vh" height="6.5vh" viewBox="0 0 32 32">
          <circle cx="16" cy="16" r="14" stroke="#006400" stroke-width="2" fill="white"/>
          <polyline points="12,14 16,20 20,14" fill="none" stroke="#006400" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>}
			</div>

     {showTable&& <div className="w-[40vw] ml-12 mt-2">
        <table className="common-table-ui ">
          <thead>
            <tr>
              <th className="py-2 px-4 border-b border-gray-700 text-left w-[8vw] min-w-[90px]">
                Year
              </th>
              {data.map((row: any) => (
                <th
                  key={row.month}
                  className="py-2 px-4 border-b border-gray-700 text-left w-[8vw] min-w-[90px]"
                  style={{ fontSize: "1.5vh" }}
                >
                  {row.month}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {year.map((y: any) => (
              <tr key={y} className="hover:bg-gray-900">
                <td className="py-2 px-4 border-b border-gray-800 font-semibold">
                  {y}
                </td>
                {data.map((row: any) => (
                  <td
                    key={row.month}
                    className="py-2 px-4 border-b border-gray-800"
                    style={{ fontSize: "1.5vh" }}
                  >
                    {row[y] !== null && row[y] !== undefined
                      ? numberFormatter(row[y], 0, "$")
                      : ""}
                    {row[y] === null
                      ? numberFormatter(row?.forecasted, 0, "$")
                      : ""}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>}
    </div>
  );
};

const CustomLegend = () => (
	<div
		style={{
			display: "flex",
			gap: "1rem",
			alignItems: "center",
			color: "black",
			fontSize: "0.8rem",
		}}
	>
		<div className="flex">
      <svg width="24%" className="mr-2 mt-1" height="8">
        <rect x="0" y="0" width="100%" height="8" fill="white" />
        <line
          x1="0"
          y1="4"
          x2="100%"
          y2="4"
          stroke="gray"
          stroke-width="2"
          // stroke-dasharray="10,10"
        />
      </svg>
      <span className="text-[0.6vw]">2023</span>
    </div>
    <div className="flex">
      <svg width="24%" className="mr-2 mt-1" height="8">
        <rect x="0" y="0" width="100%" height="8" fill="white" />
        <line
          x1="0"
          y1="4"
          x2="100%"
          y2="4"
          stroke="#82C8FA"
          stroke-width="2"
          // stroke-dasharray="10,10"
        />
      </svg>{" "}
      <span className="text-[0.6vw]">2024</span>
    </div>
    <div className="flex">
      <svg width="24%" className="mr-2 mt-1" height="8">
        <rect x="0" y="0" width="100%" height="8" fill="white" />
        <line
          x1="0"
          y1="4"
          x2="100%"
          y2="4"
          stroke="#287AB5"
          stroke-width="2"
          // stroke-dasharray="10,10"
        />
      </svg>{" "}
      <span className="text-[0.6vw]">2025</span>
    </div>
    <div className="flex">
      <svg width="24%" className="mr-2 mt-1" height="8">
        <rect x="0" y="0" width="100%" height="8" fill="white" />
        <line
          x1="0"
          y1="4"
          x2="100%"
          y2="4"
          stroke="#287AB5"
          stroke-width="2"
          stroke-dasharray="10,10"
        />
      </svg>{" "}
      <span className="text-[0.6vw]">2025F</span>
    </div>
	</div>
);

export default SalesTrend;
